// used in all the Cluster Count Layers

import pTheme from '../../../../../themes/pTheme/pTheme'
const theme = pTheme

const commonClusterCountLayer = {
  type: 'symbol',
  filter: ['has', 'point_count'],
  layout: {
    'text-field': '{point_count_abbreviated}',
    'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
    'text-size': 12,
    'text-allow-overlap': true
  },
  paint: {
    'text-color': theme.palette.hpWhite
  }
}

export const clusterCountLayerHospitals = {
  id: 'cluster-count-hospitals',
  source: 'hospitals',
  ...commonClusterCountLayer
}
export const clusterCountLayerUrgentCare = {
  id: 'cluster-count-uc',
  source: 'urgentCare',
  ...commonClusterCountLayer
}
export const clusterCountLayerGrocery = {
  id: 'cluster-count-grocery',
  source: 'groceryStores',
  ...commonClusterCountLayer
}
export const clusterCountLayerChildcare = {
  id: 'cluster-count-cc',
  source: 'childCare',
  ...commonClusterCountLayer
}
export const clusterCountLayerObgyn = {
  id: 'cluster-count-obgynPhysicianFacilities',
  source: 'obgynPhysicianFacilities',
  ...commonClusterCountLayer
}

export const clusterCountLayerMentalHealthCareFacilities = {
  id: 'cluster-count-mentalHealthCareFacilities',
  source: 'mentalHealthCareFacilities',
  ...commonClusterCountLayer
}

export const clusterCountLayerFqhc = {
  id: 'cluster-count-fqhc',
  source: 'fqhc',
  ...commonClusterCountLayer
}

export const clusterCountLayerPharmacies = {
  id: 'cluster-count-pharmacies',
  source: 'pharmacies',
  ...commonClusterCountLayer,
  paint: {
    'text-color': theme.palette.hpWhite
  }
}
export const clusterCountLayerHousehold = {
  id: 'cluster-count-household',
  source: 'uniqueHouseholdsSource',
  type: 'symbol',
  filter: ['has', 'point_count'],
  layout: {
    'text-field': '{point_count_abbreviated}',
    'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
    'text-size': 12,
    'text-allow-overlap': true
  },
  paint: {
    'text-color': theme.palette.hpAccentBlack
  }
}

// used in all Cluster Layers
const commonClusterLayer = {
  type: 'circle',
  filter: ['has', 'point_count'],
  paint: {
    'circle-radius': ['step', ['get', 'point_count'], 10, 100, 15, 500, 20, 750, 25],
    'circle-opacity': 0.85,
    'circle-stroke-color': theme.palette.hpWhite,
    'circle-stroke-width': 1
  }
}

export const clusterLayerHospitals = {
  id: 'clusters-hospitals',
  source: 'hospitals',
  ...commonClusterLayer
}

export const clusterLayerUrgentCare = {
  id: 'clusters-urgentCare',
  source: 'urgentCare',
  ...commonClusterLayer
}

export const clusterLayerGrocery = {
  id: 'clusters-grocery',
  source: 'groceryStores',
  ...commonClusterLayer
}

export const clusterLayerPharmacy = {
  id: 'clusters-pharmacy',
  source: 'pharmacies',
  ...commonClusterLayer
}

export const clusterLayerChildcare = {
  id: 'clusters-childcare',
  source: 'childCare',
  ...commonClusterLayer
}
export const clusterLayerObgyn = {
  id: 'clusters-obgynPhysicianFacilities',
  source: 'obgynPhysicianFacilities',
  ...commonClusterLayer
}

export const clusterLayerMentalHealthCareFacilities = {
  id: 'clusters-mentalHealthCareFacilities',
  source: 'mentalHealthCareFacilities',
  ...commonClusterLayer
}

export const clusterLayerFqhc = {
  id: 'clusters-fqhc',
  source: 'fqhc',
  ...commonClusterLayer
}

export const clusterLayerHousehold = {
  id: 'cluster-household',
  source: 'uniqueHouseholdsSource',
  type: 'circle',
  filter: ['has', 'point_count'],
  paint: {
    'circle-radius': ['step', ['get', 'point_count'], 10, 100, 15, 500, 20, 1000, 24, 1500, 28, 2000, 32],
    'circle-opacity': 0.8,
    'circle-stroke-color': theme.palette.hpWhite,
    'circle-stroke-width': 1,
    'circle-color': theme.palette.hpAccentPink
  }
}

// used in all Unclustered Points
const commonUnclusteredLayer = {
  type: 'symbol',
  filter: ['!', ['has', 'point_count']]
}

export const unclusteredLayerOutreachPartial = {
  id: 'partial-enrolled',
  source: 'uniqueHouseholdsSource',
  layout: {
    'icon-image': 'multicolor-circle',
    'icon-size': 0.07,
    'icon-allow-overlap': true
  },
  ...commonUnclusteredLayer
}

export const unclusteredLayerHospitals = {
  id: 'unclustered-hospitals',
  source: 'hospitals',
  ...commonUnclusteredLayer
}

// Unclustered layer for urgentCare
export const unclusteredLayerUrgentCare = {
  id: 'unclustered-urgentCare',
  source: 'urgentCare',
  ...commonUnclusteredLayer
}

// Unclustered layer for grocery
export const unclusteredLayerGrocery = {
  id: 'unclustered-groceryStores',
  source: 'groceryStores',
  ...commonUnclusteredLayer
}

// Unclustered layer for pharmacy
export const unclusteredLayerPharmacy = {
  id: 'unclustered-pharmacies',
  source: 'pharmacies',
  ...commonUnclusteredLayer
}

// Unclustered layer for Childcare
export const unclusteredLayerChildcare = {
  id: 'unclustered-childCare',
  source: 'childCare',
  ...commonUnclusteredLayer
}

export const unclusteredLayerObgyn = {
  id: 'unclustered-obgynPhysicianFacilities',
  source: 'obgynPhysicianFacilities',
  ...commonUnclusteredLayer
}

export const unclusteredLayerMentalHealthCareFacilities = {
  id: 'unclustered-mentalHealthCareFacilities',
  source: 'mentalHealthCareFacilities',
  ...commonUnclusteredLayer
}

export const unclusteredLayerFqhc = {
  id: 'unclustered-fqhc',
  source: 'fqhc',
  ...commonUnclusteredLayer
}

export const unclusteredLayerHousehold = {
  id: 'unclustered-uniqueHousehold',
  source: 'uniqueHouseholdsSource',
  type: 'circle',
  filter: ['!', ['has', 'point_count']],
  paint: {
    'circle-radius': 4, // Smaller circle size
    'circle-opacity': 0.8,
    'circle-stroke-color': theme.palette.hpWhite,
    'circle-stroke-width': 0.5,
    'circle-color': theme.palette.hpAccentPink
  }
}

/**
 * List of variables and their purpose:
 *
 * - clusterCountLayerHospitals: Configuration for the cluster count layer for hospitals.
 * - clusterCountLayerUrgentCare: Configuration for the cluster count layer for urgent care facilities.
 * - clusterCountLayerGrocery: Configuration for the cluster count layer for grocery stores.
 * - clusterCountLayerChildcare: Configuration for the cluster count layer for childcare facilities.
 * - clusterCountLayerObgyn: Configuration for the cluster count layer for OB-GYN physician facilities.
 * - clusterCountLayerMentalHealthCareFacilities: Configuration for the cluster count layer for mental health care facilities.
 * - clusterCountLayerFqhc: Configuration for the cluster count layer for Federally Qualified Health Centers and Service Sites.
 * - clusterCountLayerPharmacies: Configuration for the cluster count layer for pharmacies.
 * - clusterCountLayerHousehold: Configuration for the cluster count layer for unique households.
 * - clusterLayerHospitals: Configuration for the cluster layer for hospitals.
 * - clusterLayerUrgentCare: Configuration for the cluster layer for urgent care facilities.
 * - clusterLayerGrocery: Configuration for the cluster layer for grocery stores.
 * - clusterLayerPharmacy: Configuration for the cluster layer for pharmacies.
 * - clusterLayerChildcare: Configuration for the cluster layer for childcare facilities.
 * - clusterLayerObgyn: Configuration for the cluster layer for OB-GYN physician facilities.
 * - clusterLayerMentalHealthCareFacilities: Configuration for the cluster layer for mental health care facilities.
 * - clusterLayerFqhc: Configuration for the cluster layer for Federally Qualified Health Centers and Service Sites.
 * - clusterLayerHousehold: Configuration for the cluster layer for unique households.
 * - unclusteredLayerOutreachPartial: Configuration for the unclustered layer for partially enrolled outreach households.
 * - unclusteredLayerHospitals: Configuration for the unclustered layer for hospitals.
 * - unclusteredLayerUrgentCare: Configuration for the unclustered layer for urgent care facilities.
 * - unclusteredLayerGrocery: Configuration for the unclustered layer for grocery stores.
 * - unclusteredLayerPharmacy: Configuration for the unclustered layer for pharmacies.
 * - unclusteredLayerChildcare: Configuration for the unclustered layer for childcare facilities.
 * - unclusteredLayerObgyn: Configuration for the unclustered layer for OB-GYN physician facilities.
 * - unclusteredLayerMentalHealthCareFacilities: Configuration for the unclustered layer for mental health care facilities.
 * - unclusteredLayerFqhc: Configuration for the unclustered layer for Federally Qualified Health Centers and Service Sites.
 * - unclusteredLayerHousehold: Configuration for the unclustered layer for unique households.
 */
